import {inject, Injectable, NgZone} from '@angular/core';
import {App} from "@capacitor/app";
import {DataUpdateService} from "./data-update.service";
import {PwaService} from "./pwa.service";
import {isNative} from "../utils";
import { CapacitorUpdater, NoNeedEvent } from '@capgo/capacitor-updater';

@Injectable({
  providedIn: 'root'
})
export class ResumeService {
  private readonly dataUpdateService = inject(DataUpdateService);
  private readonly ngZone = inject(NgZone);
  private readonly pwaService = inject(PwaService);

  public initialize() {
    console.log("Initialize called!");
    if(!isNative) {
      App.addListener('resume', () => {
        this.ngZone.run(() => this.update())
      });
      this.update();
    } else {
      console.log("Registering listeners for native app...");
      // CapacitorUpdater.addListener(
      //   'appReady',
      //   () => {
      //     console.log("App ready:");
      //     this.update();
      //   }
      // )
      CapacitorUpdater.addListener(
        'noNeedUpdate',
        (e: NoNeedEvent) => {
          this.update();
        }
      );
      this.update();
    }
  }

  private async update() {
    console.log("Updating data on resume...");
    if (!isNative) {
      await this.pwaService.checkForUpdates();
    }
    console.log("Checking for updates...");
    await this.dataUpdateService.updateData();
  }
}
